export let BillableStateType = /*#__PURE__*/function (BillableStateType) {
  BillableStateType["Billable"] = "billable";
  BillableStateType["NonBillable"] = "nonBillable";
  return BillableStateType;
}({});
export let NonBillableReason = /*#__PURE__*/function (NonBillableReason) {
  NonBillableReason["IssuingInvoice"] = "issuingInvoice";
  NonBillableReason["BilledMaxCharges"] = "billedMaxCharges";
  return NonBillableReason;
}({});